@import '@hevoio/hevo-ui-toolkit/styles/variables';

.rootContainer {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.fieldName {
  font-weight: $font-weight-medium;
  flex-shrink: 1;
}

.fieldType {
  margin-left: $spacer * 0.5;
  flex-shrink: 1;
  color: $text-secondary;
}

.rootContainer {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.keyBadge {
  flex-shrink: 0;
  margin-left: $spacer * 0.25;
}
